module.exports = __webpack_public_path__ + "img/rear-2.13ae0adf.jpg";